import React from "react";

const ActiveIcon = ({ isActive }) => {
    if (isActive) {
        return (
            <img src={require('../../img/icon-good-16.png')} alt="active"/>
        );
    } else {
        return (
            <img src={require('../../img/icon-unknown-16.png')} alt="inactive"/>
        );
    }
}

export default ActiveIcon;